module.exports = __webpack_public_path__ + "img/img05.e617de1d.png";